import type { Doc } from "building-types/doc";
import type { PropAttributesHandle } from "building-types/handles/docEntityHandleTypes";
import type { PropInstance } from "building-types/props/propInstanceTypes";
import type { PropAttributes } from "building-types/props/propTypes";
import type { Table } from "common/data/table";
import { builtInPropAttributes } from "../elements/propCatalog/builtInProps";

function docGetPropAttributesFromId(doc: Doc, id: string | undefined): PropAttributes | null {
  if (id && doc.propAttributes[id]) {
    return doc.propAttributes[id];
  }

  return null;
}

export function docGetPropLabels(doc: Doc, prop: PropInstance): Table<boolean> {
  const propAttributes = docGetPropAttributesFromId(doc, prop.propType);
  return { ...propAttributes?.labels, ...prop.labels };
}

export function docGetPropAttributes(doc: Doc, { settingsHandle, id }: PropAttributesHandle): PropAttributes | null {
  if (!settingsHandle?.id) {
    return doc.propAttributes[id] || builtInPropAttributes[id];
  }
  return null;
}
